import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import * as styles from './Spiner.module.scss'

function Spiner({ reversed, width, height, className }) {
  const inlineStyles = { width, height }

  return (
    <div className={classNames(styles.loadingSpinnerWrapper, className)}>
      <div
        style={inlineStyles}
        className={classNames(
          styles.loadingSpinner,
          reversed && styles.reversed
        )}
      />
    </div>
  )
}

Spiner.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  reversed: PropTypes.bool,
}

export default Spiner
